import { throwErrorWithId } from '@pypestream/utils';

import { getDefaultMessagesPypes, resolveBotSolutionIds } from '../../utils';
import { Pype } from '../prostudio.api-service.types';
import { ProStudioContext, ProStudioEvents } from '../prostudio.xstate.types';

export interface DefaultMessagesData {
  defaultMessagesPypes: { live: Pype[]; sandbox: Pype[] };
}

export const loadDefaultMessages = async (
  ctx: ProStudioContext,
  _event: ProStudioEvents
): Promise<DefaultMessagesData> => {
  const projectId = ctx.project?.id;
  const uniqueCustomerId = ctx.project?.projectProStudioSetting?.customerId;

  if (!projectId) {
    throwErrorWithId('Project ID is required');
  }
  if (!uniqueCustomerId) {
    throwErrorWithId('Customer ID is required');
  }

  // This page is scoped to the selected solution, so the read must be too.
  // Failing loudly rather than falling back to a customer-wide read: the rows are
  // editable, and silently listing another solution's channels would let someone
  // rewrite messages they never navigated to.
  // Every id this solution's streams may carry — a legacy solution's old channels
  // keep its `botSolutionId`.
  const botIds = resolveBotSolutionIds(ctx);

  if (!botIds.length) {
    throwErrorWithId('Bot ID is required');
  }

  const defaultMessagesPypes = await getDefaultMessagesPypes({
    uniqueCustomerId: uniqueCustomerId!,
    projectId: projectId!,
    botId: botIds,
  });

  return { defaultMessagesPypes };
};
